"use client";

import { Button, Icon, Logo, Stack, Typography } from "components";
import { withContent } from "contexts/content";
import { helper, openUrl } from "utils";

function PartnerContact({ config, redirect }) {
  return (
    <Stack className="BupPartner-contact" component="section">
      <Typography variant="h3">¿Tienes dudas?</Typography>
      <Stack spacing={2}>
        <Typography className="Bup-subtitle" variant="span">
          Te ayudamos a resolverlas, contáctanos.
        </Typography>
        <Stack spacing={3}>
          <Typography>
            Llámanos o escríbenos al +569 2392 6125 ó al correo
            contacto@bondup.cl
            <br /> Horario de atención: Lunes a Viernes de 9:00 a 18:00 hrs.
          </Typography>
          <Stack
            flexDirection={{ xs: "col", sm: "row" }}
            spacing={1}
            useFlexGap
          >
            <Button
              id="BB-register-3"
              className="BupButton-wide"
              color="inherit"
              onClick={() =>
                redirect.register({ params: { signUpCode: "BCH" } })
              }
              size="large"
              variant="text"
            >
              Acceder al beneficio <Logo />
            </Button>
            <Button
              id="BB-register-4"
              className="BupButton-wide"
              endIcon={<Icon name="whatsapp" variant="fb" />}
              onClick={() =>
                openUrl(helper.getWhatsappUrl(config?.contact?.phone))
              }
              size="large"
            >
              Whatsapp
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
}

export default withContent(PartnerContact);
